import Vue from 'vue'
import Vuex from 'vuex'
import {
  mutations
} from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

const state = {
  user: {
    id: '',
    login: ''
  },
  maps: [],
  // ignKey, lastUpdate, mode, patch
  params: {
    ignKey: 'choisirgeoportail',
    lastUpdate: '?',
    nbMaxMesu: 1000,
    nbMaxSimu: 1000,
    nbMaxSupp: 1000,
    protocolUrl: '#'

  },

  menu: {
    active: false
  },

  footer: {
    active: false
  },

  sidebar: {
    active: false
  },

  // initialisation du layer après après à paramconf/info
  ign: '',

  paramUrl: {
    // mêmes valeurs que les clés des param_conf en base.
    LAYER_FACADE: '',
    LAYER_HORIZONTAL: '',
    LAYER_ORTHO: '',
    LAYER_GEO: '',
    LAYER_OPENSTREET: '',
    URL_GEOPLATEFORME: '',
    URL_COEXYA: '',
    PNSE_ACTIF: 'false',
    NOTIF_PNSE: '',
    PNSE_SOL_ACTIF: 'false',
    PNSE_FACADE_ACTIF: 'false',
    PNSE_SOL_VISIBLE: 'false',
    PNSE_FACADE_VISIBLE: 'false',
    VIDEO_PNSE_VISIBLE: 'false',
    VIDEO_PNSE_URL: '',
    URL_FAQ: '',
    URL_COMPRENDRE_CARTORADIO: '',
    URL_GLOSSAIRE: ''
  },

  localisation: {
    active: false,
    filter: null
  },

  adresse: {
    filter: null
  },

  supports: {
    show: true,
    direction: false,
    tm: {
      show: true,
      value: 1,
      direction: false,
      operateurs: [],
      technologies: {
        '2G': {
          show: true
        },
        '3G': {
          show: true
        },
        '4G': {
          show: true
        },
        '5G': {
          show: true
        }
      },
      active: false
    },
    systemes: {
      'FM': {
        show: true
      },
      'AM': {
        show: true
      },
      'RNT': {
        show: true
      }
    },
    categories: {
      'TEL': {
        show: true
      },
      'TNT': {
        show: true
      },
      'AUTRES': {
        show: true
      },
      'PMR': {
        show: true
      },
      'FH': {
        show: true
      }
    },
    tv: {
      show: true,
      value: 2
    },
    radio: {
      show: true,
      value: 8
    },
    autre: {
      show: true,
      value: 4
    },
    mobilenetworks: {
      show: true,
      value: 64
    },
    microwavetransmission: {
      show: true,
      value: 32,
      active: true
    },
    anciennete: 720
  },

  mesures: {
    show: true,
    stations: {
      show: true,
      value: 1
    },
    objets: {
      show: true,
      value: 2
    },
    anciennete: 720,
    niveaux: [0, 87]
  },

  simulations: {
    showBackground: false,
    show: false,
    facade: {
      show: true,
      value: 1
    },
    sol: {
      show: true,
      value: 2
    }
  },

  territoires: [
    { codeign: 'FXX', name: 'France Metropole', lon: 2.5494994234241553, lat: 46.558215472382436 },
    { codeign: 'GLP', name: 'Guadeloupe', lon: -61.53978838751168, lat: 16.197608394213013 },
    { codeign: 'GUF', name: 'Guyane', lon: -53.2376464833754, lat: 3.922031427772531 },
    { codeign: 'MTQ', name: 'Martinique', lon: -61.0193946414805, lat: 14.654878210910393 },
    { codeign: 'MYT', name: 'Mayotte', lon: 45.14739665176407, lat: -12.820586863987101 },
    { codeign: 'NCL', name: 'Nouvelle-Calédonie', lon: 165.70911372961802, lat: -21.308472539403017 },
    { codeign: 'PYF', name: 'Polynésie française', lon: -145.4856832528466, lat: -15.186554656636241 },
    { codeign: 'REU', name: 'La Réunion', lon: 55.53253371493472, lat: -21.133207872191946 },
    { codeign: 'SBA', name: 'Saint-Barthelemy', lon: -62.83261962488822, lat: 17.90558452184925 },
    { codeign: 'SMA', name: 'Saint-Martin', lon: -63.05502237203228, lat: 18.07763134156437 },
    { codeign: 'SPM', name: 'Saint-Pierre-et-Miquelon', lon: -56.30761140436978, lat: 46.93429238684835 },
    { codeign: 'WLF', name: 'Wallis et Futuna', lon: -177.23068376737018, lat: -13.84739640048136 },
    { codeign: 'AUTRE', name: 'Hors ou multiple zones' }
  ],

  questionnaire: null
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
